import axios, { AxiosError } from "axios";
import {
	DEBUG,
	toaster,
	ISettings,
	RestAPI,
	IRestResult,
	IErrorRestResponse,
} from "@/loader";

export abstract class VIPSettingsRest {
	public static readonly endpoint: string = "settings";

	public static getURL() : string {
		let url: string[] = [RestAPI.url.replace(/\/$/, ""), RestAPI.namespace, VIPSettingsRest.endpoint];
		return url.join("/");
	}

	public static async list(): Promise<IRestResult<ISettings>> {
		return await axios.get<ISettings>(VIPSettingsRest.getURL()).then(response => {
			return { success: true, item: response.data };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error.response?.data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<ISettings>>{ success: false, error: error.response?.data };
		});
	}

	public static async update(data: ISettings): Promise<IRestResult<ISettings>> {
		return await axios.post<ISettings>(VIPSettingsRest.getURL(), data).then(response => {
			return { success: true, item: response.data };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error, data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<ISettings>>{ success: false, error: error.response?.data };
		});
	}
}
